import React, { useState, useEffect } from 'react';

let BOOTUP_SCREEN_ENABLED = false;

const BootupScreen = ({ children, toggle }) => {
  
    if(toggle){
        BOOTUP_SCREEN_ENABLED = true;
    }

  const [isLoading, setIsLoading] = useState(true);
  const [lines, setLines] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const bootSequence = [
    '> Initializing system...',
    '> Loading core modules... OK',
    '> Checking dependencies... OK',
    '> Establishing connections... OK',
    '> Mounting file systems... OK',
    '> Starting services... OK',
    '> System ready.',
    '> Welcome.'
  ];
  useEffect(() => {
    if (currentIndex < bootSequence.length) {
      const timeout = setTimeout(() => {
        setLines(prev => [...prev, bootSequence[currentIndex]]);
        setCurrentIndex(prev => prev + 1);
      }, 150); // Fast typing speed (150ms per line)
      return () => clearTimeout(timeout);
    } else {
      // Wait a moment then complete loading
      const finalTimeout = setTimeout(() => {
        setIsLoading(false);
      }, 500);
      return () => clearTimeout(finalTimeout);
    }
  }, [currentIndex]);

  if (!BOOTUP_SCREEN_ENABLED) {
    return <>{children}</>;
  }

  if (!isLoading) {
    return <>{children}</>;
  }
  return (
    <div className="bootup-screen" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: '#0a0a0a',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      fontFamily: "'Courier New', monospace",
      color: '#ffcc00'
    }}>
      <div className="bootup-container" style={{
        maxWidth: '600px',
        width: '90%'
      }}>
        {lines.map((line, index) => (
          <div
            key={index}
            className="normal-glow-text"
            style={{
              marginBottom: '8px',
              fontSize: '16px',
              opacity: 0,
              animation: 'fadeIn 0.3s ease-in forwards'
            }}
          >
            {line}
          </div>
        ))}
        {currentIndex < bootSequence.length && (
          <div className="bootup-cursor" style={{
            display: 'inline-block',
            width: '10px',
            height: '18px',
            backgroundColor: '#ffcc00',
            animation: 'blink 1s infinite'
          }} />
        )}
      </div>
      <style>{`
        @keyframes fadeIn {
          to {
            opacity: 1;
          }
        }
        @keyframes blink {
          0%, 49% {
            opacity: 1;
          }
          50%, 100% {
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
};
export default BootupScreen;
